import { useEffect } from 'react'

type NewRelicBrowserApi = {
    noticeError?: (error: Error, customAttributes?: Record<string, unknown>) => void
}

const useApmInit = () => {
    useEffect(() => {
        const baseConsoleError = console.error
        console.error = (...args: unknown[]) => {
            try {
                const newrelic = (window as Window & { newrelic?: NewRelicBrowserApi }).newrelic
                const message = args?.map(String).join(' ')
                if (message) {
                    newrelic?.noticeError?.(new Error(message))
                }
            } catch {
            }
            baseConsoleError.apply(console, args as Parameters<typeof console.error>)
        }

        return () => {
            console.error = baseConsoleError
        }
    }, [])
}

export default useApmInit
